import { useOverviewGeral, useOverviewGraficos, type MetricaSistema } from "../api";
import { detalheVariacao, formatCompacto, formatNumero } from "../series";
import { GradeKpis, Kpi, type Variante } from "./Kpi";

const METRICAS: { chave: MetricaSistema; rotulo: string }[] = [
  { chave: "idosos", rotulo: "Idosos cadastrados" },
  { chave: "evolucoes", rotulo: "Evoluções" },
  { chave: "usuarios", rotulo: "Usuários" },
  { chave: "administracoes", rotulo: "Administrações de medicamentos" },
  { chave: "checagens", rotulo: "Checagens" },
  { chave: "movimentacoesEstoque", rotulo: "Movimentações de estoque" },
  { chave: "sinaisVitais", rotulo: "Sinais vitais" },
  { chave: "receitasMedicas", rotulo: "Receitas médicas" },
  { chave: "emails", rotulo: "E-mails de notificação" },
  { chave: "notificacoesPortal", rotulo: "Notificações no portal" },
];

/**
 * Volume de uso do sistema: total e o que entrou no mês, da coleta diária (até ontem).
 * Idosos e usuários mostram o total em tempo real (instituicao), como a Home sempre fez.
 */
export function TelaSistema({ variante }: { variante: Variante }) {
  const tv = variante === "tv";
  const geral = useOverviewGeral({ autoAtualizar: tv });
  const graficos = useOverviewGraficos({ autoAtualizar: tv });
  const sistema = graficos.data?.sistema;
  // Na TV os totais passam dos milhões e estouram o quadro: abrevia.
  const formatar = tv ? formatCompacto : formatNumero;

  const totalAoVivo: Partial<Record<MetricaSistema, number | undefined>> = {
    idosos: geral.data?.quantidadeIdosos,
    usuarios: geral.data?.quantidadeUsuarios,
  };

  const grade = (
    <GradeKpis variante={variante} colunas={5}>
      {METRICAS.map(({ chave, rotulo }) => {
        const aoVivo = chave in totalAoVivo;
        const total = aoVivo ? totalAoVivo[chave] : sistema?.[chave]?.total;
        // Sem coleta: na TV o número some em vez de mostrar "—".
        if (tv && total == null && !(aoVivo ? geral.isLoading : graficos.isLoading)) return null;
        return (
          <Kpi
            key={chave}
            rotulo={rotulo}
            valor={formatar(total)}
            isLoading={aoVivo ? geral.isLoading : graficos.isLoading}
            variante={variante}
            detalhe={detalheVariacao(sistema?.[chave]?.mes, "no mês", formatar)}
          />
        );
      })}
    </GradeKpis>
  );
  // Na TV a grade fica centrada na altura do slide.
  return tv ? <div className="flex h-full flex-col justify-center">{grade}</div> : grade;
}
